import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";


const RegisterPage = ({ handleRegister, setAuthMode, registerError }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [organization, setOrganization] = useState("");
  const [passkey, setPasskey] = useState("");
  const navigate = useNavigate();


  const handleSubmit = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      alert("Passwords do not match!");
      return;
    }
    handleRegister(email, password, organization, passkey);
  };

  return (
    <>
      {/* Header Section */}
      <div className="header">
        <Link to="/" className="auth-header">Auden AI</Link>
      </div>

      {/* Registration Form Section */}
      <div className="auth-container">
        <div className="auth-card">
          <h2>Register</h2>
          {registerError && <p className="error-message">{registerError}</p>}
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <input
                type="text"
                placeholder="Organization"
                value={organization}
                onChange={(e) => setOrganization(e.target.value)}
                required
              />
              <input
                type="text"
                placeholder="Organization Passkey"
                value={passkey}
                onChange={(e) => setPasskey(e.target.value)}
                required
              />
            </div>
            <div className="input-group">
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div className="input-group">
              <input
                type="password"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="auth-button">Register</button>
          </form>
          <p>
            Already have an account?{" "}
            <button className="switch-auth" onClick={() => navigate("/login")}>
              Login Here
            </button>
          </p>
        </div>
      </div>
    </>
  );
};

export default RegisterPage;
